module.exports = {

    mounted() {
        /**
         * Define the behavior for the left and right keyboard operation of the navbar.
         */
        $('.navbar-nav .nav-item .nav-link').focus(function () {
            var currentLink = $(this);
            $(currentLink).on('keydown.dd', function (e) {
                if (e.which == 39) {
                    // console.log($currentLink)
                    if (currentLink.parent('.nav-item').next('.nav-item').length >= 1) {
                        currentLink.parent('.nav-item').next('.nav-item').children('.nav-link').focus()
                    }
                } else if (e.which == 37) {
                    if (currentLink.parent('.nav-item').prev('.nav-item').length >= 1) {
                        currentLink.parent('.nav-item').prev('.nav-item').children('.nav-link').focus()
                    }
                }
            });
        })
    }
}
